import './TypeFilter.scss';

import { Box } from "@mui/material";

import { Filter } from "../../common-components/Dropdowns/Dropdowns";

const TypeFilter = ({onTypeChange, reset}) => {
    const options = [
        {
            id: '0',
            is_emergency_line: '0',
            name: 'По договору'
        },
        {
            id: '1',
            is_emergency_line: '1',
            name: 'По линии ЧС'
        },
    ]

    const handleTypeChange = (option) => {
        onTypeChange(option.is_emergency_line);
    }

    return (
        <Box className={"type_filter"}>
            <Filter options={options} propertyLabel={"Вид оперативного выезда"} onOptionClick={handleTypeChange} reset={reset}/>
        </Box>
    )
}

export default TypeFilter;